// Formata valores de preço no idioma da interface (oferta da comunidade e landing pages).
const LOCALES: Record<string, string> = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

export type PriceCurrency = 'EUR' | 'BRL';

export function formatPrice(value: number, currency: PriceCurrency, lang: string): string {
  return new Intl.NumberFormat(LOCALES[lang] || 'pt-BR', { style: 'currency', currency }).format(value);
}
